export default {
  title: 'Credențiale personal',
  form: {
    username: {
      label: 'Nume utilizator',
      placeholder: 'Nume utilizator',
    },
    password: {
      label: 'Parolă',
      placeholder: 'Parolă',
    },
    button: {
      title: 'Salvează',
    },
    success: 'Informațiile au fost salvate cu succes.',
  },
};
